import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { exportWireDistanceSelector, exportWireEndDeviceSelector, connectedDevicesSelector } from 'selectors/components'
import resolutionLookup from 'helpers/cameras/resolutionLookup'

const mapStateToProps = (state, ownProps) => {
  const { presentationValues, ui: { isImperial } } = state
  const distanceResult = exportWireDistanceSelector(state)

  return {
    endDevice: exportWireEndDeviceSelector(state),
    wireDistance: distanceResult && distanceResult.distance,
    closetValues: ownProps.type === 'networkCloset' && connectedDevicesSelector(state),
    presentationValues,
    isImperial
  }
}

class DescriptionBuilder extends React.Component {
  connectionText = _ => this.props.endDevice ? `is cabled to ${this.props.endDevice.name} at a length of ${this.props.wireDistance}` : 'is not cabled yet'

  cameraDescription = _ => {
    // This needs to handle fixed and ranged aov as well as camera models in the future
    const { currentDevice: { name, horizontalResolution, verticalResolution, model },
      presentationValues: { angleOfView, distance, fieldOfView, ppf }, isImperial } = this.props
    const units = isImperial ? 'ft' : 'm'

    return (
      `${name}:
       With ${resolutionLookup({ horizontalResolution, verticalResolution, model })} resolution
       and ${angleOfView.value}° AoV
       at ${distance.value} ${units} from the camera
       and ${fieldOfView.value} ${units} scene width,
       the ${isImperial ? 'PPF' : 'PPM'} is ${ppf.value}. It ${this.connectionText()}`
    )
  }

  doorControllerDescription = _ => {
    const { currentDevice: { name, doorIds } } = this.props
    const doorText = `controls ${doorIds.length} door${doorIds.length !== 1 ? 's' : ''}`

    return `${name}: ${doorText} and ${this.connectionText()}`
  }

  doorDescription = _ => {
    const { currentDevice: { name }, endDevice } = this.props

    return `${name}: is controlled by ${endDevice && endDevice.name}`
  }

  networkClosetDescription = _ => {
    const { currentDevice: { name }, closetValues: { connectedDevices, totalDistance } } = this.props

    if (connectedDevices.length === 0) return `${name}: no cabled devices`

    return `${name}: is cabled to ${connectedDevices.length} devices, with a total length of ${totalDistance}`
  }

  wiredDeviceDescription = _ => {
    const { currentDevice: { name, type } } = this.props

    return `${name}: has type ${type} and ${this.connectionText()}`
  }

  buildDescription = _ => {
    const { props: { type }, cameraDescription, doorControllerDescription, doorDescription, networkClosetDescription, wiredDeviceDescription } = this

    switch (type) {
      case 'camera':
        return cameraDescription()
      case 'doorController':
        return doorControllerDescription()
      case 'door':
        return doorDescription()
      case 'networkCloset':
        return networkClosetDescription()
      case 'wiredDevice':
      default:
        return wiredDeviceDescription()
    }
  }

  render() {
    const { isExport, currentDevice, type, addPadding, classes } = this.props

    if (!isExport) {
      return (
        <div className={classes.descriptionText} id='deviceDescriptionWrapper'>
          {this.buildDescription()}
        </div>
      )
    }

    return (
      <div className={classes.exportContainer} style={{ padding: addPadding ? '0 1rem 1rem 1rem' : 0 }}>
        <strong>Notes:</strong>
        <span className={classes.clampThree}>
          {currentDevice.notes}
        </span>
      </div>
    )
  }
}

export default connect(mapStateToProps)(injectSheet(style)(DescriptionBuilder))



// WEBPACK FOOTER //
// ./src/components/DeviceDescription/DescriptionBuilder/index.js